import type { Entity } from '../game/components'
import { canEvolve } from '../game/evolution'

// Post-unification: the one thing worth a trip home is Anagenesis. Nudge
// when the next tier is affordable and no overlay is up.
//
// Doubles as the strip's one-shot toast surface (Phase F, amoeba-input plan):
// showNotice() borrows the same element for a controller-onboarding message,
// which updateSkillNotice keeps displaying (instead of recomputing the
// Anagenesis condition) until it expires — no separate toast system needed.
let toastText: string | null = null
let toastUntil = -Infinity
let originalText: string | null = null

/** Show a one-shot message on the skill-notice strip for durationMs, then
 *  resume the normal Anagenesis-nudge logic. */
export function showNotice(text: string, durationMs = 4500): void {
  toastText = text
  toastUntil = performance.now() + durationMs
}

export function updateSkillNotice(el: HTMLElement, player: Entity, shopOpen: boolean): void {
  if (originalText === null) originalText = el.textContent ?? ''

  if (toastText !== null) {
    if (performance.now() < toastUntil) {
      el.textContent = toastText
      el.style.display = 'block'
      return
    }
    toastText = null
    el.textContent = originalText
  }

  const show = !shopOpen && canEvolve(player, player.dna ?? 0).ok
  el.style.display = show ? 'block' : 'none'
}
